export const existingAccountPrompt =
  'Already have an account? Click here to log in.';

export const createAccountPrompt = 'No account yet? Create a free one!';

export const buttonTexts = {
  create: 'Create Account',
  reset: 'Reset Password',
  login: 'Log in',
};
